export type AreaCity = { code?: number; city: string };
export type AreaPref = { code?: number; pref: string; cities: AreaCity[] };

let cache: AreaPref[] | null = null;

export async function loadAreaOptions(): Promise<AreaPref[]> {
  if (cache) return cache;
  const resp = await fetch('/api/areas');
  if (!resp.ok) throw new Error('地域マスタを取得できませんでした');
  const data = await resp.json();
  cache = Array.isArray(data?.prefs) ? data.prefs : [];
  return cache;
}

export async function normalizeAreaRemote(input: {
  name?: string;
  location?: string;
  prefecture?: string;
  municipality?: string;
}): Promise<{ prefecture?: string; municipality?: string; changed?: boolean; confidence?: number }> {
  const resp = await fetch('/api/normalize-area', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  if (!resp.ok) throw new Error('地域を正規化できませんでした');
  return await resp.json();
}
